import { defineMessages } from "react-intl";

export const homeSalesPanelMessages = defineMessages({
  awaitingPayment: {
    defaultMessage:
      "{count, plural, one {# order awaiting payment} other {# orders awaiting payment}}",
    id: "e/pGSw",
    description: "sales card, orders with no payment received",
  },
  partialDay: {
    defaultMessage: "Showing ordered value — too many orders to total today",
    id: "8ZHhvX",
    description: "sales card, fallback when the day could not be read in full",
  },
  unavailable: {
    defaultMessage: "Unavailable",
    id: "OcYbWa",
    description: "sales card, figure could not be determined",
  },
  noOrders: {
    defaultMessage: "No orders yet today",
    id: "+/t6AU",
    description: "sales card, empty state",
  },
  viewAllOrders: {
    defaultMessage: "View all orders",
    id: "/mYOZG",
    description: "sales card, link to the filtered order list",
  },
  extraLines: {
    defaultMessage: "+{count}",
    id: "5U63gh",
    description: "sales card, further items in an order",
  },
});
